import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  notifications: [] // Array of { id, type, message, progress?, fileName? }
}

// Monotonic counter so notifications dispatched within the same millisecond still
// get a unique id when the caller doesn't supply one. Without a stable unique id,
// the toast auto-dismiss timers (keyed by id) can't target the toast and it lingers.
let notificationSeq = 0

const notificationSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    addNotification: (state, action) => {
      const { id, type, message, progress, fileName } = action.payload
      state.notifications.push({
        // Fall back to a generated unique id so every toast can be auto-dismissed
        id: id ?? `ntf_${Date.now()}_${notificationSeq++}`,
        type, // 'upload', 'delete', 'success', 'error', 'warning', 'info'
        message,
        progress: progress || 0,
        fileName,
        timestamp: Date.now()
      })
    },
    updateNotificationProgress: (state, action) => {
      const { id, progress } = action.payload
      const notification = state.notifications.find(n => n.id === id)
      if (notification) {
        notification.progress = progress
      }
    },
    removeNotification: (state, action) => {
      state.notifications = state.notifications.filter(n => n.id !== action.payload)
    },
    clearNotifications: (state) => {
      state.notifications = []
    }
  }
})

export const { 
  addNotification, 
  updateNotificationProgress, 
  removeNotification, 
  clearNotifications 
} = notificationSlice.actions

export default notificationSlice.reducer

// Selectors
export const selectNotifications = (state) => state.notifications.notifications
export const selectActiveUploads = (state) => 
  state.notifications.notifications.filter(n => n.type === 'upload' && n.progress < 100)
export const selectActiveDeletes = (state) => 
  state.notifications.notifications.filter(n => n.type === 'delete')
